import xs from "xstream"
import isolate from "@cycle/isolate"
import {path} from "ramda"

import {PAGE, STATE_KEY} from '../../../constant'

import {pageViewTempl} from '../../common'

import {view} from './view'

const Top = sources => {
	const user$ = sources.state.select([STATE_KEY.User])
	const points$ = sources.state.select([STATE_KEY.Points])
	const credits$ = sources.state.select([STATE_KEY.Credits])
	const pdfEvents$ = sources.state.select([STATE_KEY.PdfEvents])
	const logs$ = sources.state.select([STATE_KEY.Logs])

	const pdf$ = sources.DOM.select("tr.downloadRow").events("click")
		.map(path(["ownerTarget", "dataset", "id"]))
		.map(id => ({href: `/pointLog/pdf/${id}`, target: "_blank"}))

	const slideEvents$ = sources.DOM.select(".badge.badge-success").events("click")
		.map(path(["ownerTarget", "dataset", "slide"]))
		.map(id => ({href: `/pdf/web/viewer.html?file=${id}`, target: "_blank"}))
	const pdf2$ = sources.DOM.select(".badge.badge-danger.jsrm63").events("click")
		.map(path(["ownerTarget", "dataset", "id"]))
		.map(id => ({href: `/pointLog/pdf/${id}`, target: "_blank"}))
	
	const password$ = sources.DOM.select(".btnPassword").events("click")
		.mapTo("/member/password")
	const logout$ = sources.DOM.select(".btnLogout").events("click")
		.mapTo("/loading")
	const return$ = sources.DOM.select(".btnReturn").events("click")
		.mapTo({ type: "goBack" })

	const view$ = view(user$, points$, credits$, pdfEvents$, logs$)

	// const initReq$ = xs.of(pointsReq({}))
	// 	.debug(() => window.scroll(0, 0))

	// const pointsState = points2State(pointsResp(sources.HTTP))

	const pageView = pageViewTempl(PAGE.Top.id)
	return {
		// HTTP: xs.merge(initReq$),
		DOM: pageView(view$),
		router: xs.merge(password$, logout$, return$),
		// state: xs.merge(pointsState),
		externalLink: xs.merge(pdf$, slideEvents$, pdf2$),
	}
}
export default sources => isolate(Top)(sources)
